import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=3fa54ae9&"
import script from "./RatingStar.vue?vue&type=script&lang=js&"
export * from "./RatingStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports